import React from 'react';

// 스크롤 포지션 훅
import ScrollPosition from '../../hook/ScrollPosition';



const Aboutabout = () => {
   const scrollPosition = ScrollPosition()
   return (
      <div className='About-about'>
         <div className={`flexCenter ${scrollPosition >= 600 ? 'originPosition' : ''}`}>
            <h1>LCDC SEOUL</h1>
            <span>르콩트 드콩트(LE CONTE DES CONTES) : ‘이야기 속의 이야기’</span>
            <p>LCDC SEOUL은 저마다의 이야기를 가진 크고 작은 브랜드들이 모여있는 공간플랫폼입니다. 여러 브랜드가 서로 협력하여 만든 각자의 이야기는 하나의 매력적인 이야기가 되어 LCDC SEOUL 속에서 펼쳐집니다.</p>
            <p>일상의 조각을 모아주는 따뜻한 카페, 다양한 브랜드를 경험할 수 있는 팝업 공간, 여행과 삶의 이야기를 담은 패션 라이프스타일 큐레이션 샵, 일상의 즐거움을 더해주는 다양한 스몰 브랜드 샵들 그리고, 못다 한 이야기를 나누는 루프탑 바. 이들 모두는 LCDC SEOUL을 이루는 다채로움 속에서 일관성과 통일성이 유지되도록 섬세하게 구성되었습니다.</p>
            <p>공간 속의 다양한 이야기는 복합적인 경험 요소들을 통해 깊이 있는 의식과 즐거움, 만족을 줄 것 입니다. LCDC SEOUL을 찾은 여러분의 하루가 하나의 이야기가 되고, 그 이야기들이 모여 이 공간의 이야기로 완성되기를 기대합니다.</p>
         </div>
         <div className={`flexCenter ${scrollPosition >= 640 ? 'originPosition' : ''}`}>
            <img src={require("../../img/about1.jpg")} alt="" />
            <img src={require("../../img/about2.jpg")} className='hoverImage' alt="" />
         </div>
      </div>
   );
};

export default Aboutabout;

